export default "__VITE_ASSET__BKwLinBW__"